import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import HomeNav from '../../../../components/HomeNav';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs } from 'react-bootstrap';
import FaultRecovery from '../assets/troubleshooting/6.1-SCC.png';
import TroubleshootProcess from '../assets/troubleshooting/6.2-troubleshooting-process.png';
import { FaHome } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const SITroubleshootOverview = () => {
	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const activeTab = queryParams.get('tab');

		if (activeTab) {
			setActiveKey(activeTab);
		}
	}, [location]);

	const [activeKey, setActiveKey] = useState('Troubleshooting Overview');
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Troubleshooting</Breadcrumb.Item>
							<Breadcrumb.Item active>Troubleshooting Overview</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs activeKey={activeKey} onSelect={setActiveKey} className="mb-3 troubleshooting-element">
								<Tab eventKey="Troubleshooting Overview" title="Troubleshooting Overview">
									<h2>TROUBLESHOOTING OVERVIEW</h2>

									<p>Proper troubleshooting is finding the cause of a problem and correcting it in a safe and systematic manner. Often, the troubleshooter’s ability to solve the problem quickly benefits the production economically.</p>

									<p>The actual steps the troubleshooter uses to achieve the ultimate goal may vary, but there are a few general rules that will make troubleshooting more effective.</p>

									<p>A good troubleshooter should follow these general rules:</p>

									<ul>
										<li>Use a clear and logical approach.</li>
										<li>Work safely.</li>
										<li>Work quickly.</li>
										<li>Work efficiently.</li>
									</ul>
								</Tab>

								<Tab eventKey="Troubleshooting Guidelines" title="Troubleshooting Guidelines">
									<h2>THE FIVE TROUBLESHOOTING GENERAL GUIDELINES</h2>

									<p>The four general rules mentioned in the Troubleshooting Overview are broad statements that govern good troubleshooting. Listed below are more specific action items, which are essential in successful troubleshooting:</p>

									<ol>
										<li>
											<h5>Verify that a problem exists.</h5>
											<p>A problem is usually indicated by a change in equipment performance or product quality. Verification of a problem through observation will allow the troubleshooter to determine if a problem actually exists, or if the reports of trouble are due to a lack of equipment understanding.</p>
										</li>
										<li>
											<h5>Identify and locate the root cause of the trouble.</h5>
											<p>Trouble is often caused by a change in the system. An understanding of the system, its sequence, its modes of operation, and how they are supposed to work, will aid in finding the cause of the trouble. After identifying the suspected component, test the component to confirm it is the culprit.</p>
										</li>
										<li>
											<h5>Correct the problem.</h5>
											<p>It is very important to correct the root of the problem, not just the symptom(s). This often involves replacing or repairing a part or making adjustments. A process or piece of equipment should never be adjusted to compensate for a problem and that action considered finishing the job: Correct the problem!</p>
										</li>
										<li>
											<h5>Verify that the problem has been corrected.</h5>
											<p>Repeating the same check that originally indicated the problem can often do this. If the fault has been corrected, the system should operate properly. Test the system.</p>
										</li>
										<li>
											<h5>Follow up to prevent further trouble.</h5>
											<p>A plan should be suggested that would prevent a future recurrence of this problem.</p>
										</li>
									</ol>
								</Tab>

								<Tab eventKey="Experience" title="Experience">
									<h2>EXPERIENCE</h2>

									<p>There is a way to capture a small part of the experience of personnel so those who have not seen a particular event for themselves can refer to it in the future. Equipment history or an equipment trouble log can tell quite a tale over the life of a piece of equipment.</p>

									<p>The trouble log provides a valuable source of information that draws on the experience of past troubles and troubleshooting efforts, to quickly restore the equipment to service. Problems, symptoms, corrective actions, modifications, and preventive maintenance actions should all have entries that can be referenced at a later date.</p>
								</Tab>

								<Tab eventKey="Step-by-Step Approach" title="Step-by-Step Approach">
									<h2>STEP-BY-STEP APPROACH</h2>

									<p>Troubleshooting a problem is a logical, step-by-step procedure. The approach is much the same for all equipment; only the steps for implementing the approach may differ.</p>
									<p>All maintenance personnel can use general troubleshooting procedures. The basic approach is listed below:</p>

									<ul>
										<li>
											Talk with the operator. Read the <b>HMI</b>.
										</li>
										<li>
											Read the Alarm and Warning messages on the <b>HMI</b> screen. Faults generally fall within the following three categories:
											<ul>
												<li>Safety Faults (Safety Faults)</li>
												<li>Fixture Faults (Switch Faults)</li>
												<li>Communication (Profinet Faults)</li>
											</ul>
										</li>
										<li>Define Problem Area.</li>
										<li>Identify Possible Causes.</li>
										<li>Solve the problem.</li>
										<li>Make final checks. This includes testing the system.</li>
										<li>Complete equipment logs and paperwork.</li>
										<li>Inform area supervision/instruct operators.</li>
									</ul>
								</Tab>

								<Tab eventKey="Intermittent Failures" title="Intermittent Failures">
									<h2>INTERMITTENT FAILURES</h2>

									<p>An intermittent failure can be a much more difficult problem for the troubleshooter. It also can create havoc within a process or a system operation. However, diagnosing the fault can be accomplished using these general guidelines:</p>

									<p>Attempt to recreate the problem. It may be:</p>

									<ul>
										<li>Electrically induced failure.</li>
										<li>Mechanically induced failure.</li>
									</ul>
									<p>Isolate the fault once the problem re-occurs:</p>
									<ul>
										<li>But you have to recreate the conditions so the fault can reoccur.</li>
										<li>Monitor the operation if the problem does not re-occur. </li>
									</ul>

									<p>If the fault does not reoccur, you need to monitor the equipment operation for an extended period of time.</p>
								</Tab>

								{/* <Tab eventKey="Sequence Stops" title="Sequence Stops">
									<h2>SEQUENCE STOPS</h2>

									<p>
										Sequence stops encompass a broad range of problems, most of which only require simple repair. Most sequence stops can be traced to a limit or proximity switch that has not been tripped. A <b>PLC</b> network controls the sequencing of components. When an input is received, it initializes the appropriate output based on current system logic. These sensor devices are in use constantly during machine operation. Most problems with sequencing can be attributed to dirty, faulty, or maladjusted switches. In less common cases, sequence stops are due to an output device not activating. Problems here can range from failed actuators to a logic failure. Isolating either problem can be done quickly with a basic understanding of machine operation and station controls.
									</p>

									<p>Problems not attributed to output device failure may be the result of a physical disconnection. Look for broken air lines, loose cable connections, or mechanical obstruction. In the event of sensor failure, examine the actuating device to determine if the stop occurred before or after the mid-range point of the actuated device. If the stop occurs before midpoint, this indicates an advance sensor failure. A stop past midpoint signifies a retract sensor failure. If the problem cannot be physically identified, use wiring diagrams to locate the output module for the actuating device.</p>
								</Tab> */}

								<Tab eventKey="Root Cause" title="Root Cause">
									<h2>ROOT CAUSE</h2>

									<p>Simply fixing a problem does not necessarily solve it. One problem may merely be a symptom of another problem. Many times, the repair of a problem results in only temporary restoration of system performance. This is because the emphasis is often on getting the equipment up and running, not on fixing the real problem.</p>

									<p>One of the easiest ways to find the real problem is to ask, “Why did this piece of equipment fail?” If the answer to that question is that another piece of equipment has failed or is out of adjustment, then ask, “Why is that piece of equipment not running correctly?” Perform this question and answer procedure enough and you will eventually find the root cause.</p>

									<p>For example, do not just replace the fuse because the motor is drawing excessive current. The motor may have an excessive load on it because its rotor shaft bearings are bad. But it is not necessarily a bad motor because the installers may have adjusted the belt on the motor shaft too tight which causes shaft to shift causing excessive wear on one side of the bearings. This scenario could go on, but the point is that maybe the quick fix is not the real problem.</p>

									<p>
										Just remember that troubleshooting is a straightforward process in automated systems. When you encounter a problem, remember that less than 10% of all system failures will be due to the <b>PLC</b> and between 5% and 10% of all system failures are due to anything from the <b>PLC</b> out to the I/O card. By far, the most failures, 80% to 90%, in a system are due to input and output devices and the hardware they control.
									</p>
								</Tab>

								<Tab eventKey="HMI" title="HMI">
									<h2>HMI</h2>

									<p>
										The System <b>PLC</b> will diagnose most cases of the machine falling out of automatic mode. The standard ladder programming has built in diagnostics that will detect problems and display messages on the fault and warning message displays on the <b>HMI</b> screens. The <b>HMI</b> may not give you the root cause of the problem but it will display what faults have occurred and possible troubleshooting tips.
									</p>

									<p>Use the line fault screen and the various system status screens to help locate and troubleshoot the fault.</p>
								</Tab>

								<Tab eventKey="Fault Recovery Procedure" title="Fault Recovery Procedure">
									<div class="tab-section" style={{ display: 'flex' }}>
										<div class="left-side">
											<h2>FAULT RECOVERY PROCEDURE</h2>
											<p>The following procedure describes what to do in the event of a fault condition.</p>

											<ol>
												<li>
													When a fault occurs, the red light on the <b>HMI</b> will illuminate.
												</li>
												<li>
													At the <b>HMI</b>, read the description to determine the cause. Once the reason for the fault is remedied, press the RESET button, and reset the safety circuit.
												</li>
											</ol>
										</div>
										<div class="right-side">
											<figure style={{ width: '44vw' }}>
												<img src={FaultRecovery} alt="Fault Recovery" style={{ width: '100%' }} />
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Troubleshooting Process" title="Troubleshooting Process">
									<div class="tab-section" style={{ display: 'flex' }}>
										<div class="left-side">
											<h2>TROUBLESHOOTING PROCESS</h2>
											<h5>Important Notes:</h5>
											<ol>
												<li>Remember, anytime you approach the machine, take it out of Auto Mode for Safety!</li>
												<li>The inputs are OK, but the output is not being turned on...must be something in-between. If you do not have a processor fault light...suspect the I/O modules. Before changing out an input or output module, a meter check should be made on the module to ensure that the module lights are working properly.</li>
												<li>Anytime that the output light (on the output module) does not agree with the logic... suspect the output module. Anytime that the logic does not agree with the I/O lights...suspect the I/O modules (95% true) Before changing an input or output module, a meter check should be made on the module to ensure that the module lights are working properly.</li>
												<li>Be aware of blown fuse lights or any adaptor lights indicating faults in the communications. Remember that there should be some input lights illuminated... if there are no lights at all, suspect a power issue. A meter check can ensure that the Module's input lights are working properly.</li>
												<li>The Real World also includes broken wires, mechanical jams... A meter check can be made to verify the Input module's lights are working properly.</li>
												<li>Remember that motion causing outputs use switched power supply. This should have been picked up by the diagnostic messages. A meter check can ensure that the Module's input light is working properly.</li>
											</ol>
										</div>
										<div class="right-side">
											<figure style={{ width: '32vw' }}>
												<img src={TroubleshootProcess} alt="Troubleshoot Process" style={{ width: '100%' }} />
											</figure>
										</div>
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SITroubleshootOverview;
